<template>
  <div class="d-flex flex-column align-content-around">
    <div class="flex-column align-content-center">
      <div class="d-flex flex-row justify-content-start align-content-center">
        <calc-controls-client-select />
        <calc-controls-agent-select class="ml-3"/>
      </div>
      <hr :style="{height: 0}" />
      <calc-controls-route-point-select :point-type="RoutePointTypes.ORIGIN" />
      <calc-controls-route-point-select :point-type="RoutePointTypes.DESTINATION" class="mt-2" />
      <hr :style="{height: 0}" />
      <div class="d-flex flex-row justify-content-around align-content-center">
        <calc-controls-cargo-types-select />
      </div>
    </div>
    <calc-controls-cargo
      class="mt-3"
      v-show="showCargo"
    />
  </div>
</template>

<script>
import { RoutePointTypes } from '../enums'
import { mdbBtn, mdbRow, mdbCol } from 'mdbvue'
import { mapState } from 'vuex'
import CalcControlsRoutePointSelect from './CalcControlsRoutePointSelect'
import CalcControlsClientSelect from './CalcControlsClientSelect'
import CalcControlsAgentSelect from './CalcControlsAgentSelect'
import CalcControlsCargo from './CalcControlsCargo'
import CalcControlsCargoTypesSelect from './CalcControlsCargoTypesSelect'

export default {
  name: 'CalcControls',
  data: function () {
    return {
      RoutePointTypes: RoutePointTypes
    }
  },
  computed: {
    ...mapState('calc', {
      qid: state => state.query.qid,
      routePoints: state => state.query.routePoints,
      measureUnits: state => state.data.measureUnits
    }),
    showCargo: {
      get: function () {
        return this.routePoints[RoutePointTypes.ORIGIN] &&
          this.routePoints[RoutePointTypes.DESTINATION] &&
          this.measureUnits.length > 0
      }
    }
  },
  components: {
    CalcControlsCargoTypesSelect,
    CalcControlsCargo,
    CalcControlsAgentSelect,
    CalcControlsClientSelect,
    CalcControlsRoutePointSelect,
    mdbBtn,
    mdbRow,
    mdbCol
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcControls.vue